import { render, staticRenderFns } from "./AbaVisualizacoesAviso.vue?vue&type=template&id=41996244&scoped=true"
import script from "./AbaVisualizacoesAviso.vue?vue&type=script&lang=ts"
export * from "./AbaVisualizacoesAviso.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41996244",
  null
  
)

export default component.exports